<template>
  <card-list title="Transaksi Berhasil" data-url="/api/v1/po/success" data-size="10" printUrl="/po/print"
    previewUrl="/po/preview/:id:" :dataHeaders="tHeaders" />
</template>
<script>
import CardList from "../../components/CardList";
export default {
  components: {
    CardList
  },
  data () {
    return {
      tHeaders: [
        { supplier_name: "Suplier", align: 'left', type: 'text' },
        { inv_po: "No PO", align: 'left', type: 'text' },
        { faktur: "Faktur", align: 'left', type: 'text' },
        { created_at: "Created At", align: 'left', type: 'datetime' },
        { total: "Total", align: 'right', type: 'number' },
      ]
    }
  }
};
</script>